import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    name: {
        color: 'white',
        fontSize: 21,
        textAlign: 'right',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: 16,
        },
    },
    mode: {
        color: '#7A7883',
        fontSize: 17,
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: 14,
        },
    },
    avatarContainer: {
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
    avatar: {
        marginLeft: 15,
        borderWidth: 1,
        borderColor: '#FF5A67',
        borderRadius: 55,
        width: 55,
        height: 55,
        objectFit: 'cover',
        borderStyle: 'solid',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            width: 35,
            height: 35,
        },
    },
    dropdownButton: {
        cursor: 'pointer',
        width: 'auto',
    },
    menu: {
        padding: '1rem',
        marginTop: theme.spacing(8),
        [theme.breakpoints.up('md')]: {
            marginLeft: -theme.spacing(5),
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: -theme.spacing(12),
        },
    },
    menuItem: {
        padding: '1.25rem 1.25rem',
    },
    menuItemIcon: {
        marginRight: 25,
    },
    logoutButton: {
        marginTop: '1rem',
        marginBottom: '1rem',
        fontSize: 18,
        width: '100%',
        justifyContent: 'center',
    },
    logoutButtonLabel: {
        color: theme.palette.primary.main,
    },
    loginButton: {
        borderRadius: 50,
        padding: '0 48px',
        fontSize: 18,
        height: 51,
        borderWidth: 0,
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            height: 34,
            borderRadius: 34,
            padding: '0 30px',
            fontSize: '14px',
        },
    },
    influencerButtons: {
        marginTop: theme.spacing(2),
    },
}));
